import React from 'react';
import { Link } from 'react-router-dom';

function Home({ translations }) {
  return (
    <div className="home">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-slogan">{translations.slogan}</h1>
          <p className="hero-subtitle">{translations.sloganSubtitle}</p>
          <div className="hero-buttons">
            <Link to="/solutions" className="btn btn-primary">{translations.exploreSolutions}</Link>
            <Link to="/contact" className="btn btn-secondary">{translations.contactUs}</Link>
          </div>
        </div>
      </div>

      <section className="products-section">
        <div className="products-container">
          <h2 className="section-title">{translations.ourProducts}</h2>
          <div className="products-grid">
            <div className="product-card">
              <img src="/AI Virtual Mentor Logo.png" alt="AI Virtual Mentor" className="product-logo" />
              <h3>{translations.productVirtualMentor}</h3>
              <p>{translations.productVirtualMentorDesc}</p>
              <Link to="/solutions?product=virtual-mentor" className="product-cta">{translations.learnMore} →</Link>
            </div>
            <div className="product-card">
              <img src="/AI-smartflow-Logo.png" alt="AI SmartFlow" className="product-logo" />
              <h3>{translations.productSmartFlow}</h3>
              <p>{translations.productSmartFlowDesc}</p>
              <Link to="/solutions?product=smartflow" className="product-cta">{translations.learnMore} →</Link>
            </div>
            <div className="product-card">
              <img src="/translide-logo.png" alt="Translide" className="product-logo" />
              <h3>{translations.productTranslide}</h3>
              <p>{translations.productTranslideDesc}</p>
              <a href="https://translide.co" target="_blank" rel="noopener noreferrer" className="product-cta">{translations.tryTranslide} →</a>
            </div>
            <div className="product-card">
              <img src="/gressio-logo.png" alt="Gressio" className="product-logo" />
              <h3>{translations.productGressio}</h3>
              <p>{translations.productGressioDesc}</p>
              <a href="https://gressio.ai" target="_blank" rel="noopener noreferrer" className="product-cta">{translations.tryGressio} →</a>
            </div>
          </div>
        </div>
      </section>

      <section className="scenarios-section">
        <div className="scenarios-container">
          <h2 className="section-title">{translations.businessScenarios}</h2>
          <div className="scenarios-grid">
            <div className="scenario-card">
              <span className="scenario-category">{translations.salesTraining}</span>
              <h3>{translations.salesTrainingDesc}</h3>
            </div>
            <div className="scenario-card">
              <span className="scenario-category">{translations.searchingAnswers}</span>
              <h3>{translations.searchingAnswersDesc}</h3>
            </div>
            <div className="scenario-card">
              <span className="scenario-category">{translations.knowledgeSharing}</span>
              <h3>{translations.knowledgeSharingDesc}</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
